import { render } from "./dt-dash.vue?vue&type=template&id=63ac5530&scoped=true"
import script from "./dt-dash.vue?vue&type=script&lang=js"
export * from "./dt-dash.vue?vue&type=script&lang=js"

import "./dt-dash.vue?vue&type=style&index=0&id=63ac5530&lang=scss"
import "./dt-dash.vue?vue&type=style&index=1&id=63ac5530&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ac5530"]])

export default __exports__